export default __webpack_public_path__ + "static/douglas-863fe96e324d1b5d53c1154ac17fd99b.png";